import packageJson from "../../package.json" with { type: "json" };

// In CAC page-hosting the app lives under HOSTED_BASENAME
// (`/pages/<pathname>/...`, per common-node's generatePageUrl). In local
// dev/preview Vite serves under LOCAL_BASENAME (matches the shared vite
// config's `base: "/assets/"`).
const HOSTED_BASENAME = `/pages/${packageJson.config.creditAcceptancePageHosting.pathname}`;
const LOCAL_BASENAME = "/assets";

/**
 * The router basename for the current runtime, detected from the URL so the
 * same bundle works in page-hosting and in local dev/preview. Also used to
 * build absolute in-app URLs for `window.open` (which, unlike React Router
 * links, needs the basename included).
 * @returns {string} The basename prefix, or "" when neither prefix is present.
 */
export function getBasename(): string {
  const pathname = globalThis.location?.pathname ?? "";
  if (pathname.startsWith(HOSTED_BASENAME)) {
    return HOSTED_BASENAME;
  }
  if (pathname.startsWith(LOCAL_BASENAME)) {
    return LOCAL_BASENAME;
  }
  return "";
}
